<h1>
  {{'There has been an error, please contact the Solarlux team!' | translate}}
</h1>
